@use "../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      :global([contenteditable="true"]:focus) {
        outline: none;
      }

      .container {
        width: 100%;
        min-height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        border: none;
        position: relative;
      }

      .loading {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.6);
        opacity: 0.4;
      }

      .editorContainer {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
      }

      .editorContentWrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;

        &.bordered {
          padding: 0.5rem 0.75rem;
          border-radius: 0.25rem;
          border: 1px solid colors.$mmc-accent-gray;
        }
      }

      .editorContent {
        flex: 1;
        min-height: 0;
        overflow: auto;
      }

      .toolbar {
        position: absolute;
        bottom: 1rem;
        right: 1rem;
        left: 1rem;
        box-shadow: 0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.06);
        padding: 0.25rem 0.5rem;
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }

      .divider {
        border-color: colors.$mmc-slate-010;
        margin: 0.5rem 0;
      }

      .sizeSmall {
        font-size: 0.75rem;
        line-height: 1.125rem;
      }

      .sizeMedium {
        font-size: 0.875rem;
        line-height: 1.25rem;
      }

      .sizeLarge {
        font-size: 1.125rem;
        line-height: 1.625rem;
      }

      .editable {
        flex: 1;
        width: 100%;
        font-size: 0.875rem;
        font-weight: 400;
        border-radius: 0.25rem;
        min-height: 18.75rem;
        line-height: 1.375rem;
        resize: none;
        color: colors.$mmc-black;
        padding: 0;
        p {
          margin-bottom: 0;
        }
        &[disabled],
        &:disabled {
          background: #f5f5f5; // mimic default "disabled" background for inputs
          color: colors.$mmc-disabled-gray;
          outline: none;

          & [data-slate-placeholder] {
            opacity: 1 !important;
          }
        }
      }

      .actionsAndToolbarWrapper {
        margin-top: 0.5rem;
      }
    }
  }
}
